module.exports = __webpack_public_path__ + "media/images/character/zen_chan_bowing-c20153349f857d054c2ed477dd5eab7f.png";